import React, { useState, useRef } from 'react';
import { Link, useParams } from "react-router";

import useSWR, { mutate } from 'swr'
import axios from 'axios'

import GroupAppVersionList from './GroupAppVersionList'

import fetch from 'isomorphic-unfetch'
const fetcher = url => fetch(url).then(r => r.json())



function GroupView() {

  let { group_id } = useParams();
  const { data, error } = useSWR('/api/groups/' + group_id, fetcher)
  const [showJSON, setShowJSON] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [title, setTitle] = useState('')

  const titleInput = useRef(null);

  function toggleShowJSON(){
    setShowJSON(!showJSON)
  }

  const changeTitle = (e) => {
    setTitle(e.target.value)
  }

  function toggleForm(){
    console.log("running toggle form")
    setTitle(data.group.title)
    setShowForm(!showForm)
  }

  function dontToggle(event){
    event.stopPropagation()
  }

  const submitForm = () => {
    if(title === ''){
      setErrorMessage('Fields not set')
    } else {
      setErrorMessage('')
      const formData = new FormData()
      formData.append('title', title)
      formData.append('group_id', data.group.id)

      const endpoint = '/api/groups'
      axios.put(endpoint, formData, {}).then(res => {
        console.log(res)
        // reset the form/reload the versions list
        setTitle('')
        titleInput.value = null

        setErrorMessage('')
        setShowForm(false)

        // tell swr to refresh any data using this endpoint
        mutate('/api/groups/' + group_id)
      }).catch(err => {
        console.log(err)
      })
    }
  }



  // TODO: turn these into components
  if (error) return <div className="loading"><p>Failed to load. The server is probably down.</p></div>
  if (!data) return <div className="loading"><p>Loading...</p></div>

  function postGroupVersion(ids){
    console.log("Should set app_id:" + ids.app_id + " version_id:" + ids.version_id + " on group_id:" + group_id)
    const formData = new FormData()
    formData.append('group_id', group_id)
    formData.append('version_id', ids.version_id)
    formData.append('app_id', ids.app_id)

    const endpoint = '/api/groups/app_version'
    axios.post(endpoint, formData, {}).then(res => {
      console.log(res)

      // tell swr to refresh any data using this endpoint
      mutate('/api/groups/' + group_id)
      // swr isn't refreshing all the things so...
      // window.location.reload(false);
    }).catch(err => {
      console.log(err)
    })

  }

  return(
    <div>
      <h1>{data.group.title} <button className="inline-control-small inline-right" onClick={toggleForm}><span>edit</span></button></h1>
      <p><Link to={"/groups"}>Back</Link></p>

      <div className="form" style={{ display: (showForm ? "block" : "none")}}  onClick={toggleForm}>
        <div className="form-modal" onClick={dontToggle} >
          <h3>Edit Group</h3>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input ref={titleInput} type="text" value={title} placeholder="New Group" name="title" onChange={changeTitle}></input></p>
          <p><input type='submit' value='Save' onClick={submitForm} /></p>
        </div>
      </div>

      <div className="grid">
        <GroupAppVersionList data={data} postGroupVersion={postGroupVersion} />
      </div>

      <div>
        <h1>JSON OUTPUT <button className="inline-control-small" onClick={toggleShowJSON}><span>{showJSON ? "hide" : "show"}</span></button></h1>
        <pre className={showJSON ? "" : "hidden"}>{JSON.stringify(data, null, 3)}</pre>
      </div>
    </div>
  )
}


export default GroupView;
